export default {
    "language": {
        "info": "Exibindo _START_ a _END_ de _TOTAL_ registros",
        "infoEmpty": "Exibindo 0 a 0 de 0 registros",
        "infoFiltered": "(filtrado de _MAX_ registros)",
        "zeroRecords": "Nenhum registro encontrado",
        "paginate": {
            "next": "Próxima",
            "previous": "Anterior"
        }
    },
}
